// extracted by mini-css-extract-plugin
export default {"templates":"twihX6","inspirationalCarousel":"oUAQU5","desktopOnly":"oVDFNl","headingWrapper":"jlTyn5","withBlankCanvas":"SsUyP2"};